import {graneroInstance} from '@apps-common/geocorn-sdk/api';

export function removeEmpty(obj = {}) {
  return Object.keys(obj)
    .filter(k => obj[k] !== null)
    .reduce((a, k) => ({...a, [k]: obj[k]}), {});
}

export const graneroPager = (config, key, each) => {
  // maxItems - how many results to load.
  const maxItems = config?.maxItems ?? Infinity;
  const pageSize = config.params?.limit;

  return new Promise((resolve, reject) => {
    let count = 0;
    let all;
    if (!each) {
      // eslint-disable-next-line no-param-reassign
      each = data => {
        if (!all) {
          all = {
            ...data,
            [key]: data[key],
          };
        } else {
          all = {
            ...all,
            [key]: [...all[key], ...data[key]],
          };
        }
        return true;
      };
    }

    const handler = response => {
      const data = response.data[key];
      count += data.length;
      let done = count >= maxItems;
      if (done) {
        data.length = data.length - (count - maxItems);
      }
      if (!done && pageSize) {
        // avoid fetching last empty page
        done = data.length < pageSize;
      }

      const nextLink = (response?.data?.links ?? []).find(
        link => link.rel === 'next'
      )?.href;

      const more = !done && !!nextLink;

      const next = !more
        ? () => {}
        : () => {
            const url = new URL(nextLink);
            const params = Object.fromEntries(url.searchParams.entries());
            graneroInstance
              .request({
                ...config,
                params: {
                  ...config.params,
                  ...params,
                },
              })
              .then(handler)
              .catch(reject);
          };

      const keepGoing = each(response.data, more, next);

      if (keepGoing === false) {
        return;
      }

      if (!done && more) {
        next();
      } else {
        resolve({...all, links: response.data.links});
      }
    };

    graneroInstance.request(config).then(handler).catch(reject);
  });
};

// Extract error message from Features API response.
export function getErrorMessage(error, defaultMessage = 'An error occurred') {
  const responseData = error?.response?.data;

  if (Array.isArray(responseData)) {
    return responseData[0] ?? defaultMessage;
  }

  if (typeof responseData === 'string') {
    return responseData;
  }

  return defaultMessage;
}
